import React from 'react';

/**
 * Empty NavBar component - this is just a placeholder to prevent import errors.
 * Navigation is now handled by the sidebar.
 */
const NavBar = () => {
  return null;
};

export default NavBar; 